import React, { useContext, useEffect } from 'react';
import { useStore } from 'stores/Store';
import List from 'components/list/List';
import ListBody from 'components/list/ListBody';
import TemplatesListItem from 'containers/partials/list-items/TemplatesListItem';
import { StoreContext } from 'index';
import useSelectable from 'hooks/utils/useSelectable';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import {
  ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION,
  ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_EXERCISES,
  ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTIONS
} from 'routes/RouteList';
import EmptyCollectionList from 'containers/pages/exercises/collections/EmptyCollectionList';
import useCollections from 'hooks/queries/useCollections';
import { TemplateType } from 'constants';
import Loader from 'components/loader/Loader';

const OtherCollectionsTab = () => {
  const {
    authStore: { user }
  } = useContext(StoreContext);
  const { push } = useHistory();
  const { entityId, tab, templateId } = useParams();
  const { selected, select } = useSelectable([]);

  const collections = useStore(state => state.collections);
  const { fetchCollections, filterCollections, loading } =
    useCollections(entityId);

  useEffect(() => {
    fetchCollections({
      variables: { entityId, type: TemplateType.COLLECTION }
    });
  }, []);

  const onClickHandler = collection => {
    push(
      generatePath(ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION_EXERCISES, {
        entityId,
        tab,
        templateId: collection.id
      })
    );
  };

  const onEditHandler = collection => {
    push(
      generatePath(ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTION, {
        entityId,
        tab,
        templateId: collection.id
      })
    );
  };

  const onDeleteHandler = templateId => {
    push(
      generatePath(ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTIONS, {
        entityId,
        tab,
        templateId
      })
    );
  };

  const onSearch = e => {
    filterCollections({ search: e.target.value });
  };

  return (
    <>
      {loading && <Loader />}
      {/* TODO: fix!  */}
      {/* <FieldInput
                rounded
                icon="search-grey"
                iconLeft
                onChange={onSearch}
              /> */}

      {collections &&
      collections.length &&
      collections.filter(t => t.personId !== user.id).length ? (
        <List>
          {/* <ListHeader noTitleStatus>
                <ListColumnTitle
                // ascendent // in comment totdat het werkt:
                // TODO: rangschikking list by column title
                >
                  <FormattedMessage
                    {...messages.collectionsHeaderListCollections}
                  />
                </ListColumnTitle>
                <ListColumnTitle>
                  <FormattedMessage
                    {...messages.collectionsHeaderListExercisesQty}
                  />
                </ListColumnTitle>
              </ListHeader> */}
          <ListBody>
            {collections
              .filter(t => t.personId !== user.id)
              .map(collection => (
                <TemplatesListItem
                  checkbox={false}
                  icon="template"
                  mediumIcon
                  visible={selected.length > 0}
                  exercisesLength={collection.exercises.length}
                  id={collection.id}
                  key={collection.id}
                  template={collection}
                  entityId={entityId}
                  active={collection.id === templateId}
                  checked={selected.includes(collection.id)}
                  onChange={() => select(collection.id)}
                  onClick={() => {
                    return onClickHandler(collection);
                  }}
                  onEdit={() => onEditHandler(collection)}
                  onDeleted={() => onDeleteHandler(templateId)}
                />
              ))}
          </ListBody>
        </List>
      ) : (
        <EmptyCollectionList />
      )}
    </>
  );
};

export default OtherCollectionsTab;
